import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const {
    palette: { primary, text },
    breakpoints
  } = theme;

  return {
    pageRoot: {
      position: "relative",
      zIndex: 1210,
      borderLeft: `1px solid ${primary.light}`
    },
    pageContent: {
      display: "block",
      backgroundColor: "#fff"
    },
    noContent: {
      paddingTop: 110,
      color: text.secondary,
      height: "auto",
      width: "100%"
    },
    loader: {
      height: "calc(100dvh - 166px)",
      [breakpoints.down(Breakpoints.SM_600)]: {
        height: "calc(100dvh - 212px)"
      },
      [breakpoints.down(Breakpoints.XS_420)]: {
        height: "calc(100dvh - 204px)"
      }
    }
  };
});
